<script>
import CopyToClipboard from '@/Components/Utilities/CopyToClipboard.vue'
import BlueButton from '@/Components/Buttons/BlueButton.vue'
import GreyButton from '@/Components/Buttons/GreyButton.vue'
import LoadingIndicator from '@/Components/Utilities/LoadingIndicator.vue'
import {Inertia} from '@inertiajs/inertia'

export default {
    components: {LoadingIndicator, GreyButton, CopyToClipboard, BlueButton},
    props: {
        email: {
            type: String,
            required: true
        },
        customerId: {
            type: Number,
            default: undefined
        },
        id: {
            type: Number,
            required: true
        },
        inviteUrl: {
            type: String,
            required: true
        },
        provisioned: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close'],
    data() {
        return {
            sending: false
        }
    },
    methods: {
        sendEmail() {
            this.sending = true

            const inviteRoute = this.provisioned
                ? route('crm.invite.send', {customer: this.customerId})
                : route('crm.invite.send')

            Inertia.post(inviteRoute, {id: this.id}, {
                onFinish: () => {
                    this.sending = false
                }
            })
        },
        closeModal() {
            this.$page.props.flash.modal.show = false
            this.$emit('close')
        }
    }
}
</script>

<template>
    <div class="p-6 max-w-xl">
        <div v-if="provisioned">
            Click send email to send the new user an invitation to their system. Alternatively, you can copy the link
            below and send it to them to get them started.
        </div>
        <div v-else>
            Click send email to send your new user an invitation to the system. Alternatively, you can copy the link
            below and send it to them to get started.
        </div>
        <CopyToClipboard
            v-slot="{ copied, copy }"
            copy-target="#invite-url"
        >
            <div class="flex items-center mt-3">
                <a
                    id="invite-url"
                    class="p-1 text-xs hover:text-rss-blue-500 truncate bg-grey-200"
                    :href="inviteUrl"
                    target="_blank"
                >
                    {{ inviteUrl }}
                </a>
                <button
                    class="p-2 ml-2 text-rss-blue-50 uppercase bg-rss-blue-500 rounded-full focus:outline-none focus:ring focus:ring-rss-blue-300 hover:shadow-md transition duration-300 ease-in-out"
                    @click="copy"
                >
                    <svg
                        v-show="copied"
                        class="w-8 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 13l4 4L19 7"
                        />
                    </svg>
                    <svg
                        v-show="!copied"
                        class="w-8 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                        />
                    </svg>
                </button>
            </div>
        </CopyToClipboard>
        <div class="flex justify-between mt-10">
            <GreyButton
                button-classes="text-xs"
                @click="closeModal"
            >
                Close
            </GreyButton>
            <BlueButton
                button-classes="flex items-center text-xs"
                :disabled="sending"
                @click="sendEmail"
            >
                Send Email
                <LoadingIndicator
                    :loading="sending"
                    indicator-classes="ml-2 w-4"
                />
            </BlueButton>
        </div>
    </div>
</template>
